import api from '../../components/api'
import { CostCode } from './costCode'

export const getCostCodes = async () => {
  const response = await api.get<CostCode[]>('/costcodes')
  return response.data
}

export const updateCostCode = async (costCode: CostCode) => {
  await api.post<CostCode>('/web/cost-codes', costCode)
}

export type QboItem = {
  id: string
  displayName: string
}

export const getQboItems = async () => {
  const response = await api.get<QboItem[]>('/quickbooks/items')
  return response.data
}

export const deleteCostCode = async (id: number) => {
  await api.delete(`/web/cost-codes/${id}`)
}